/** Média por coleta, segura contra divisão por zero (sem coleta no período). */
export const safeAverage = (total: number, collectCount: number): number =>
  collectCount > 0 ? total / collectCount : 0;

/** Formata com 1 casa decimal, padrão pt-BR (vírgula) — "por coleta" do card 3. */
export const formatOneDecimal = (value: number): string =>
  value.toLocaleString("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
